import { messages as enGB } from './en-GB'
import { messages as ptBR } from './pt-BR'

export { phones } from './parsedPhones'

export const linguiLocales = {
  'en-GB': enGB,
  'pt-BR': ptBR,
}

export const linguiDefaultLocale = 'en-GB'